interface GeolocationResult {
  lat: number;
  lon: number;
  accuracy: number;
}

export class GeolocationService {
  private static readonly GOOGLE_API_URL = 'https://www.googleapis.com/geolocation/v1/geolocate';

  static async getLocation(): Promise<GeolocationResult | null> {
    try {
      const apiKey = process.env.NEXT_PUBLIC_GOOGLE_GEOLOCATION_API_KEY;
      if (!apiKey) {
        console.warn('Google Geolocation API key not configured');
        return null;
      }

      const response = await fetch(`${this.GOOGLE_API_URL}?key=${apiKey}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          considerIp: true,
        }),
      });

      if (!response.ok) {
        console.warn('Google Geolocation API failed:', response.status);
        return null;
      }

      const data = await response.json();

      if (
        data.location &&
        typeof data.location.lat === 'number' &&
        typeof data.location.lng === 'number'
      ) {
        return {
          lat: data.location.lat,
          lon: data.location.lng,
          accuracy: data.accuracy || 1000,
        };
      }

      return null;
    } catch (error) {
      console.warn('Google geolocation failed:', error);
      return null;
    }
  }
}
